import { render, staticRenderFns } from "./GitDiffCode.vue?vue&type=template&id=154ccc6d&scoped=true"
import script from "./GitDiffCode.vue?vue&type=script&lang=js"
export * from "./GitDiffCode.vue?vue&type=script&lang=js"
import style0 from "./GitDiffCode.vue?vue&type=style&index=0&id=154ccc6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ccc6d",
  null
  
)

export default component.exports